import { createBrowserRouter, type RouteObject } from "react-router-dom";

export const STATIC_PAGE_HANDLE = { staticPage: true } as const;

/**
 * vite-react-ssg adds a build-specific JSON loader even to routes without data.
 * Static pages already have their content in the bundle, so those requests only
 * make old tabs fail after deployment. Strip the generated loaders from explicitly
 * marked pages in the browser; leave the build routes and data routes intact.
 */
export function removeStaticPageLoaders(routes: RouteObject[]): RouteObject[] {
  return routes.map((route) => {
    const loader = route.handle?.staticPage === true ? undefined : route.loader;
    if (route.index === true) return { ...route, loader };
    return {
      ...route,
      loader,
      children: route.children && removeStaticPageLoaders(route.children),
    };
  });
}

export const createMarketingBrowserRouter: typeof createBrowserRouter = (
  routes,
  options,
) => createBrowserRouter(removeStaticPageLoaders(routes), options);
